import { useCallback, useMemo } from 'react'
import { QueryParamConfigMap, StringParam, useQueryParams } from 'use-query-params'
import { CONTACT_FILTER_GROUPS, TContactFilterSelection } from './filters'

const QUERY_PARAM_CONFIG: QueryParamConfigMap = CONTACT_FILTER_GROUPS.reduce(
  (config, group) => ({ ...config, [group.key]: StringParam }),
  {},
)

const toPillKey = (value: unknown): string | undefined =>
  typeof value === 'string' && value.length > 0 ? value : undefined

type TUseContactFilterPills = {
  selection: TContactFilterSelection
  togglePill: (groupKey: string, pillKey: string) => void
}

export const useContactFilterPills = (): TUseContactFilterPills => {
  const [params, setParams] = useQueryParams(QUERY_PARAM_CONFIG)

  const selectionKey = CONTACT_FILTER_GROUPS.map(group => `${group.key}=${toPillKey(params[group.key]) ?? ''}`).join(
    '&',
  )

  const selection = useMemo<TContactFilterSelection>(
    () => CONTACT_FILTER_GROUPS.reduce((acc, group) => ({ ...acc, [group.key]: toPillKey(params[group.key]) }), {}),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectionKey],
  )

  const togglePill = useCallback(
    (groupKey: string, pillKey: string) => {
      // One pill per group: picking another pill replaces the current one, picking the current
      // one clears the group.
      const next = selection[groupKey] === pillKey ? undefined : pillKey

      setParams({ [groupKey]: next }, 'replaceIn')
    },
    [selection, setParams],
  )

  return { selection, togglePill }
}
